import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem('adminToken');
  const isAdminRoute = location.pathname.startsWith('/admin');

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/');
    window.location.reload();
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="logo">
          <h1>AI CoE</h1>
          <span className="subtitle">{isAdminRoute ? 'Admin Portal' : 'Center of Excellence'}</span>
        </div>
        <ul className="nav-links">
          {isAdminRoute && isAuthenticated ? (
            // Admin Navigation
            <>
              <li>
                <Link to="/admin/dashboard" className={isActive('/admin/dashboard')}>
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/admin/projects" className={isActive('/admin/projects')}>
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/admin/research" className={isActive('/admin/research')}>
                  Research
                </Link>
              </li>
              <li>
                <Link to="/admin/contacts" className={isActive('/admin/contacts')}>
                  Contacts
                </Link>
              </li>
              <li>
                <Link to="/admin/subscribers" className={isActive('/admin/subscribers')}>
                  Subscribers
                </Link>
              </li>
              <li>
                <Link to="/" className="public-link">
                  Public Site
                </Link>
              </li>
              <li>
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </li>
            </>
          ) : (
            // Public Navigation
            <>
              <li>
                <Link to="/" className={isActive('/')}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/research" className={isActive('/research')}>
                  Research
                </Link>
              </li>
              <li>
                <Link to="/projects" className={isActive('/projects')}>
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/contact" className={isActive('/contact')}>
                  Contact
                </Link>
              </li>
              {isAuthenticated ? (
                <li>
                  <Link to="/admin/dashboard" className="admin-link">
                    Dashboard
                  </Link>
                </li>
              ) : (
                <li>
                  <Link to="/admin/login" className={`admin-link ${isActive('/admin/login')}`}>
                    Admin
                  </Link>
                </li>
              )}
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
